import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { injectTranslate, TranslatePipe } from '@core/i18n-legacy';
import { OfferStatusIndicatorComponent } from '@core/offers-ui';
import { HiringResourceKind } from '@core/tellent-assign-members-to-jobs-types';
import {
  CheckboxComponent,
  ChipsComponent,
  DividerComponent,
  DropdownItemComponent,
  EmptyStateDefaultComponent,
  IconComponent,
  MultiselectFeatureDirective,
  MultiSelectTriggerComponent,
  SearchFeatureDirective,
  Select2Component,
  Select2Item,
  Select2ListItemDirective,
  Select2SelectedItemDirective,
  SelectedItemCounterDirective,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-hiring-resource-select',
  templateUrl: './hiring-resource-select.component.html',
  imports: [
    Select2Component,
    ReactiveFormsModule,
    MultiselectFeatureDirective,
    SearchFeatureDirective,
    ChipsComponent,
    OfferStatusIndicatorComponent,
    Select2SelectedItemDirective,
    MultiSelectTriggerComponent,
    CheckboxComponent,
    DropdownItemComponent,
    Select2ListItemDirective,
    SelectedItemCounterDirective,
    DividerComponent,
    IconComponent,
    TranslatePipe,
    EmptyStateDefaultComponent,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HiringResourceSelectComponent {
  private readonly t = injectTranslate();

  public readonly HiringResourceKind = HiringResourceKind;

  public items = input.required<Select2Item[]>();
  public control = input.required<FormControl>();
  public placeholder = input<string>();
  public resourceKind = input.required<HiringResourceKind>();
  public itemsLoading = input<boolean>(true);

  public resolveLocation(locations: string[]): string {
    if (locations.length === 1) return locations[0].toString();

    if (locations.length > 1)
      return `${locations.length} ${this.t('tlc.assign_members_to_jobs.dialog.locations')}`;

    return '';
  }
}
